import { apiClient } from "../../../lib";

export const recurringApi = {

    getRecurringList: async ({ projectId }: { projectId: string | undefined }): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/recurring-task-lists`);
        return response.data;
    },

    getRecurringTaskEvents: async ({ projectId, activityId, page, limit, filter }: { projectId: string | undefined, activityId: string, page: number, limit: number, filter: string }): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/recurring-task-history?page=${page}&limit=${limit}&activity_id=${activityId}&filter=${filter}`);
        return response.data;
    },

    getRecurringTasks: async ({ projectId, startDate, endDate }: { projectId: string | undefined, startDate?: string, endDate?: string }): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/recurring-tasks?startDate=${startDate}&endDate=${endDate}`);
        return response.data;
    },

    getRecurringTaskHistory: async ({ projectId, activityId, dueDate }: { projectId: string | undefined, activityId: string | undefined, dueDate: string | undefined }): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/recurring-task-event?activity_id=${activityId}&dueDate=${dueDate}`);
        return response.data;
    },

    completeRecurringTask: async ({ projectId, taskId }: { projectId: string | undefined, taskId: string }, payload: { due_date: string, completion_notes: string }): Promise<any> => {
        const response = await apiClient.post(`/projects/${projectId}/recurring-tasks/${taskId}/complete`, payload);
        return response.data;
    },

};